export default __webpack_public_path__ + "static/media/Crowne Plaza.3b8c4d53.jpg";